module.exports = __webpack_public_path__ + "static/img/9.70eee56.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/eng/9.png
// module id = 6Z0J
// module chunks = 0